import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Form, Button } from 'react-bootstrap';
import { VscLoading } from 'react-icons/vsc';
import { toast } from 'react-toastify';
import { callCenterApi } from '@/_services/api/callCenter';
import { BsArrowRepeat as RefreshIcon } from 'react-icons/bs';
import { css } from '@emotion/react';
import dayjs from 'dayjs';
import { Switch } from '@/_elements/FormElements';
import { FaPhone } from 'react-icons/fa';

const noteContainer = css`
    padding: 0.5rem 1rem;
    border-radius: 6px;
    border: 1px solid #ccc;
    p {
        margin-bottom: 0.5rem !important;
    }
`;
const noteTitle = css`
    display: flex;
    align-items: center;
    p {
        color: #000000;
        font-weight: bold;
    }
    span {
        display: flex;
        flex-wrap: no-wrap;
        font-size: 12px;
        color: #686868;
        margin-left: 2%;
        vertical-align: center;
        align-self: center;
        margin-bottom: 3px;
    }
`;

const CallCenterNoteItem = ({ note }) => {
    return (
        <div key={note._id} className="mb-4" css={noteContainer}>
            <div css={noteTitle}>
                <p>{(note?.createdBy || {})?.name || ''} </p>
                <span>{dayjs(note?.createdAt || null).format('MM-DD-YYYY h:mm A')}</span>
                {note?.call && (
                    <span title={'This note is taken from call'}>
                        <FaPhone />
                    </span>
                )}
            </div>
            <p>{note.text}</p>
        </div>
    );
};

export default CallCenterNoteItem;
